import type { ReactNode } from "react";
import { cn } from "../../lib/utils";

interface ErrorMessageProps {
  children?: ReactNode;
  message?: ReactNode;
  className?: string;
}

/** Inline-Fehlermeldung in `text-destructive`. Entweder `children` oder `message` übergeben. */
export function ErrorMessage({ children, message, className }: ErrorMessageProps) {
  const content = children ?? message;
  if (!content) return null;
  return (
    <p role="alert" className={cn("text-sm text-destructive", className)}>
      {content}
    </p>
  );
}
